"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isSimpleObject_1 = __importDefault(require("./isSimpleObject"));
const deepMerge = (...objects) => {
    let result = {};
    objects.forEach((obj) => {
        if ((0, isSimpleObject_1.default)(obj)) {
            if (!(0, isSimpleObject_1.default)(result))
                result = {};
            Object.entries(obj).forEach(([key, value]) => {
                if ((0, isSimpleObject_1.default)(value)) {
                    result[key] = deepMerge(result[key], value);
                }
                else {
                    result[key] = value;
                }
            });
        }
        else {
            result = obj;
        }
    });
    return result;
};
exports.default = deepMerge;
